import { Stack, styled } from '@mui/material';
import { portalPaths } from '@provision/portal-routes';
import { Navigate } from 'react-router-dom';
import { isNullish } from 'remeda';
import { NamedLayoutBlock } from 'src/components';
import { useGlobalStore } from 'src/store';
import { useScreenDimensions } from 'src/utils/system';
import { SubscriptionsReportTable } from './subscriptions-table';

const ReportsLayout = styled(Stack, { name: 'ReportsLayout' })(({ theme }) => ({
  position: 'relative',
  height: '100%',
  flexDirection: 'row',
  padding: theme.spacing(1),
}));

export const Reports = () => {
  const { isMobile } = useScreenDimensions();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  if (isMobile || isNullish(selectedPartnerId)) {
    return <Navigate to={portalPaths.root()} replace />;
  }

  return (
    <ReportsLayout>
      <NamedLayoutBlock title="Subscriptions">
        <SubscriptionsReportTable />
      </NamedLayoutBlock>
    </ReportsLayout>
  );
};
